import { authedApiInstance } from '../../../firebase';

export async function banUser(roomId: string, userId: string) {
    await authedApiInstance.post(`/room/${roomId}/ban/${userId}`);
}
